export const AUTH_COOKIE_NAME = "m24hr-admin";

const AUTH_COOKIE_MAX_AGE_SECONDS = 7 * 24 * 60 * 60;

export const setAuthToken = (token) => {
  if (!token) return;

  document.cookie = `${AUTH_COOKIE_NAME}=${encodeURIComponent(token)}; path=/; max-age=${AUTH_COOKIE_MAX_AGE_SECONDS}; samesite=lax`;
};

export const getAuthToken = () => {
  const cookiePair = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${AUTH_COOKIE_NAME}=`));

  if (!cookiePair) return null;

  return decodeURIComponent(cookiePair.slice(AUTH_COOKIE_NAME.length + 1));
};

export const clearAuthToken = () => {
  document.cookie = `${AUTH_COOKIE_NAME}=; path=/; max-age=0; samesite=lax`;
};

export const isAdminLoggedIn = () => Boolean(getAuthToken());

export const extractTokenFromResponse = (payload) =>
  payload?.token ||
  payload?.accessToken ||
  payload?.data?.token ||
  payload?.data?.accessToken ||
  payload?.data?.data?.token ||
  payload?.data?.data?.accessToken ||
  null;
